export const FORM_DEFAULT_REQUIRED = {
  value: true,
  message: 'Required'
}

export const FORM_CONTROL_MODIFY_ID = 'control-modify-form'
